import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入工具类
import utils from '@/util/utilsHome';
var markerClustererTest = null;
import { deviceListMapInfo } from '@/api/overview/bigScreen.js';
export default {
  name: 'deviceMap',
  // 父组件传来的参数
  props: ['domIdStr', // id追加的字符：目的是解决同一个页面同时使用多个此组件时，id相同问题
  'isSetCenter', // 是否根据设备点设置中心点
  'mapLevel' // 地图级别
  ],
  data: function data() {
    return {
      // 地图展示相关
      arr: [],
      // 存放设备信息，并赋予title,deviceId,address等属性
      point: [],
      // 存放标注点经纬度信息
      marker: [],
      // 存放标注点对象
      mapObj: null,
      // 地图对象
      styleJson: [],
      // 个性化地图的json样式代码
      device: [],
      // 将经纬度相同的点存放在一个组里
      pointsimplify: [],
      // 存放删除了重复点的点数据
      clickEvent: 0,
      // 当前点击显示弹窗序号
      devpanelOnline: [],
      // 存储设备在线状态
      devicehtml: '1111',
      // 地图设备信息中标题的html代码
      pointList: [],
      showFlag: false,
      contactData: []
    };
  },
  created: function created() {},
  mounted: function mounted() {
    // 获取设备地图信息
    this.mapList();
  },
  watch: {
    qpMapShow: function qpMapShow(newVal) {
      if (newVal) {
        this.mapList();
      }
    }
  },
  methods: {
    showAll: function showAll() {
      this.showFlag = !this.showFlag;
      this.pointList = this.device;
    },

    /*
     * 方法函数
     */
    // 点击 地图展示的 全屏
    fullScreenClick: function fullScreenClick() {
      utils.notificationInfo('提示', '开发中！', 'warning');
    },
    // 添加标注点和信息面板
    addmarkerandInfo: function addmarkerandInfo() {
      var _this2 = this;

      var _this = this;

      this.mapObj = new BMap.Map("allmap" + this.domIdStr); // 创建Map实例

      this.mapObj.centerAndZoom(new BMap.Point(this.arr[0].lon, this.arr[0].lat), 10); // 初始化地图,设置中心点坐标和地图级别

      this.mapObj.enableScrollWheelZoom(true); //启用滚轮放大缩小

      this.mapObj.setCurrentCity("中国"); // 设置地图显示的城市 此项是必须设置的

      var mapStyle = 'midnight'; // 午夜蓝

      this.mapObj.setMapStyle({
        style: mapStyle
      });
      var clusterMarkers = [];
      var markers = [];
      var pt = null; // console.log(this.contactData,'---contactData---')

      var _loop = function _loop(i) {
        point = new BMap.Point(_this2.contactData[i].lon, _this2.contactData[i].lat);
        var index = _this2.contactData[i].onlineFlag * 1;
        myIcon = new BMap.Icon(require('@/assets/img/globalPage/icon1Status' + _this2.contactData[i].onlineFlag * 1 + '.png'), new BMap.Size(47, 49));
        marker = new BMap.Marker(point, {
          icon: myIcon
        }); // 创建标注

        markers.push(marker);
        label = new BMap.Label(_this2.contactData[i].list.length, {
          offset: new BMap.Size(40, 8)
        });

        _this2.mapObj.addOverlay(marker);

        marker.setLabel(label);
        marker.addEventListener("click", function (e) {
          _this.showDivBox(_this.contactData[i]);
        }); //   label.setStyle({
        //     lineHeight: "25px",
        //     height: "23px",
        //     color: "red",
        //     left: '30px',
        //     padding: "0 ",
        //   })
      };

      for (var i = 0; i < this.contactData.length; i++) {
        var point;
        var myIcon;
        var marker;
        var label;

        _loop(i);
      }

      this.mapObj.addEventListener("zoomend", function (res) {// _this.mapObj.clearOverlays()
        // console.log(_this.mapObj.getZoom(),'.getDemo.getDemozoomend handele')
        //   let curZoom = _this.mapObj.getZoom()
        //   let Clumarkers = []
        //    _this.moreMarkers()
      }); // markerClustererTest = new BMapLib.MarkerClusterer(this.mapObj, {markers:markers});
    },
    moreMarkers: function moreMarkers() {
      var _this3 = this;

      var _this = this;

      var markers = [];

      var _loop2 = function _loop2(i) {
        if (!_this3.arr[i].list) {
          return "continue";
        }

        point = new BMap.Point(_this3.contactData[i].lon, _this3.contactData[i].lat);
        var index = _this3.contactData[i].onlineFlag * 1;
        myIcon = new BMap.Icon(require('@/assets/img/globalPage/icon1Status' + _this3.arr[i].onlineFlag * 1 + '.png'), new BMap.Size(47, 49));
        marker = new BMap.Marker(point, {
          icon: myIcon
        }); // 创建标注

        markers.push(marker);
        label = new BMap.Label(_this3.contactData[i].list.length, {
          offset: new BMap.Size(40, 8)
        });

        _this3.mapObj.addOverlay(marker);

        marker.setLabel(label);
        marker.addEventListener("click", function (e) {
          _this.showDivBox(_this.contactData[i]);
        });
        label.setStyle({
          lineHeight: "25px",
          height: "23px",
          color: "red",
          left: '30px',
          padding: "0 "
        });
      };

      for (var i = 0; i < this.contactData.length; i++) {
        var point;
        var myIcon;
        var marker;
        var label;

        var _ret = _loop2(i);

        if (_ret === "continue") continue;
      }
    },
    showDivBox: function showDivBox(obj) {
      var that = this;
      this.showFlag = true;
      this.pointList = [];
      var ary = [];
      var findIndex = -1;
      var itemlat = obj.lat.toString().slice(0, 7);
      var itemlon = obj.lon.toString().slice(0, 8);
      findIndex = this.contactData.findIndex(function (key) {
        return key.lat == itemlat && key.lon == itemlon;
      });
      this.pointList = this.contactData[findIndex].list;
    },
    todevice: function todevice(obj) {
      var that = this;
      that.$store.dispatch('SetDefaultStationFun', obj).then(function (res) {
        that.$emit('selectStation', obj);
        that.$router.push('/deviceOverview');
      });
    },
    // 关闭设备信息面板
    closepanel: function closepanel() {
      this.showFlag = false;
    },
    // 获取设备地图信息
    mapList: function mapList() {
      var _this4 = this;

      deviceListMapInfo().then(function (res) {
        if (res.data.code !== 200) {
          utils.notificationInfo('错误提示', res.data.error);
          return;
        }

        if (res.data.data) {
          var data = res.data.data;
          data.map(function (item) {
            item.location = JSON.parse(item.location);
          });
          _this4.device = data;
          var arr = [];

          if (data.length > 0) {
            data.map(function (item) {
              var obj = item.location;
              obj.onlineFlag = item.onlineFlag;
              var filterIndex = arr.findIndex(function (item) {
                return item.lat == obj.lat && item.lon == obj.lon;
              });

              if (!obj.list) {
                obj.list = [];
                obj.list.push(item);
              } else {
                arr[filterIndex].list.push(item);
              }

              arr.push(obj);
            });
            _this4.arr = arr;
            var contactData = [];
            arr.forEach(function (item) {
              var itemlat = item.lat.toString().slice(0, 7);
              var itemlon = item.lon.toString().slice(0, 8);
              var findIndex = -1;
              findIndex = contactData.findIndex(function (key) {
                return key.lat == itemlat && key.lon == itemlon;
              }); // defaultMore.push(item.list[0]);

              if (!contactData.length) {
                contactData.push({
                  lat: itemlat,
                  lon: itemlon,
                  onlineFlag: item.onlineFlag,
                  list: [item.list[0]]
                });
              } else if (findIndex > -1) {
                contactData[findIndex].list.push(item.list[0]);
              } else {
                contactData.push({
                  lat: itemlat,
                  lon: itemlon,
                  onlineFlag: item.onlineFlag,
                  list: [item.list[0]]
                });
              }
            });
            _this4.contactData = contactData;

            _this4.addmarkerandInfo();
          } else {
            // 地图初始化
            _this4.addmarkerandInfo();
          }

          _this4.addmarkerandInfo();
        }
      });
    }
  }
};